module.exports = __webpack_public_path__ + "img/ic_empty_img_error_404.72fdf92d.png";